// Утилита для маппинга ботов
// Правильно определяет торговые пары, валюты и bot_id для каждого бота

/** Алиасы и нормализация internal `name` бота (API, WebSocket, старые сессии) → ключ из `mapping` / `getCryptoIcons`. */
export function normalizeBotName(selectedBot: string): string {
  const aliases: Record<string, string> = {
    kasusdt: 'kas',
    kas_bot: 'kas',
    solusdt: 'sol',
    sol_bot: 'sol',
    bnbusdt: 'bnb_usdt',
    bnb_usdt_bot: 'bnb_usdt',
    btcusdc: 'btc_usdc',
    btc_usdc_bot: 'btc_usdc',
    dogeusdt: 'doge_usdt',
    doge_usdt_bot: 'doge_usdt',
    ethusdt: 'eth_usdt',
    eth_usdt_bot: 'eth_usdt',
    xrpusdt: 'xrp_usdt',
    xrp_usdt_bot: 'xrp_usdt',
    btcusdt: 'btc_usdt',
    btc_usdt_bot: 'btc_usdt',
  };

  let s = (selectedBot || '').toLowerCase().trim().replace(/-/g, '_').replace(/\s+/g, '_');
  s = s.replace(/_+/g, '_').replace(/^_|_$/g, '');
  if (aliases[s]) return aliases[s];
  const compact = s.replace(/_/g, '');
  if (aliases[compact]) return aliases[compact];
  return s;
}

export interface BotMapping {
  botId: string;
  tradingPair: string;
  baseCurrency: string;
  quoteCurrency: string;
  baseCoin: string;
}

export const getBotMapping = (selectedBot: string): BotMapping => {
  const mapping: { [key: string]: BotMapping } = {
    'kas': {
      botId: 'kas_bot',
      tradingPair: 'KAS/USDT',
      baseCurrency: 'KAS',
      quoteCurrency: 'USDT',
      baseCoin: 'KAS'
    },
    'sol': {
      botId: 'sol_bot',
      tradingPair: 'SOL/USDT',
      baseCurrency: 'SOL',
      quoteCurrency: 'USDT',
      baseCoin: 'SOL'
    },
    'bnb_usdt': {
      botId: 'bnb_usdt_bot',
      tradingPair: 'BNB/USDT',
      baseCurrency: 'BNB',
      quoteCurrency: 'USDT',
      baseCoin: 'BNB'
    },
    'btc_usdc': {
      botId: 'btc_usdc_bot',
      tradingPair: 'BTC/USDC',
      baseCurrency: 'BTC',
      quoteCurrency: 'USDC',
      baseCoin: 'BTC'
    },
    'btc_usdt': {
      botId: 'btc_usdt_bot',
      tradingPair: 'BTC/USDT',
      baseCurrency: 'BTC',
      quoteCurrency: 'USDT',
      baseCoin: 'BTC'
    },
    'doge_usdt': {
      botId: 'doge_usdt_bot',
      tradingPair: 'DOGE/USDT',
      baseCurrency: 'DOGE',
      quoteCurrency: 'USDT',
      baseCoin: 'DOGE'
    },
    'eth_usdt': {
      botId: 'eth_usdt_bot',
      tradingPair: 'ETH/USDT',
      baseCurrency: 'ETH',
      quoteCurrency: 'USDT',
      baseCoin: 'ETH'
    },
    'xrp_usdt': {
      botId: 'xrp_usdt_bot',
      tradingPair: 'XRP/USDT',
      baseCurrency: 'XRP',
      quoteCurrency: 'USDT',
      baseCoin: 'XRP'
    }
  };

  const normalized = normalizeBotName(selectedBot);
  return mapping[normalized] || mapping['kas'];
};